import { EMIEnvironment, EMIEnvironmentName } from 'src/app/core/models/environment.models';

export const environment: EMIEnvironment = {
  name: EMIEnvironmentName.DEV,
  apiUrl: 'https://dev-emi.wlcmapps.com/api',
};
